/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Limits_Title6Inputs */

const en_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate limiting and quotas`)
};

const ar_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدود المعدل والحصص`)
};

const bn_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেট লিমিট ও কোটা`)
};

const de_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratenbegrenzung und Kontingente`)
};

const es_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites de uso y cuotas`)
};

const fr_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitation de débit et quotas`)
};

const pt_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de uso e quotas`)
};

const zh_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限流与配额`)
};

const tr_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hız limitleri ve kotalar`)
};

const ru_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лимиты скорости и квоты`)
};

const pl_svc_mcp_server_development_limits_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Limits_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limity tempa i kwoty`)
};

/**
* | output |
* | --- |
* | "Rate limiting and quotas" |
*
* @param {Svc_Mcp_Server_Development_Limits_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_limits_title6 = /** @type {((inputs?: Svc_Mcp_Server_Development_Limits_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Limits_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "de") return de_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "es") return es_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_limits_title6(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_limits_title6(inputs)
	return en_svc_mcp_server_development_limits_title6(inputs)
});
export { svc_mcp_server_development_limits_title6 as "svc_mcp-server-development_LIMITS_title" }